/**
 * Review stars widget – loads reviews-summary.json and fills .review-stars-widget
 * with star rating + count; link goes to reviews page with ?product=handle.
 */
(function() {
  var summaryUrl = window.__reviewStarsSummaryUrl || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'assets/reviews-summary.json' : '/assets/reviews-summary.json');
  var widgets = document.querySelectorAll('.review-stars-widget');
  if (!widgets.length) return;

  function starSvg(filled) {
    var path = filled
      ? 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'
      : 'M12 5.17l2.83 2.83-2.83 5.66 2.83 2.83-5.66 2.83-2.83-2.83-2.83 2.83L2 12l2.83-2.83 2.83 2.83 5.66-2.83zM12 2L9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2z';
    return '<svg class="review-stars-widget__star" width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path d="' + path + '" fill="currentColor"/></svg>';
  }

  function renderStars(rating) {
    var r = Math.round(Math.min(5, Math.max(0, rating)));
    var html = '<span class="review-stars-widget__stars" aria-label="Rating: ' + r + ' out of 5">';
    for (var i = 1; i <= 5; i++) html += starSvg(i <= r);
    html += '</span>';
    return html;
  }

  function fillWidget(widget, data) {
    var handle = (widget.dataset.productHandle || '').trim();
    var id = (widget.dataset.productId || '').toString();
    var showCount = widget.dataset.showCount !== 'false';
    var linkToReviews = widget.dataset.linkToReviews !== 'false';
    var reviewsPageUrl = (widget.dataset.reviewsPageUrl || '/pages/reviews').replace(/\/+$/, '');
    var info = data.by_handle && data.by_handle[handle];
    if (!info && data.products && data.products[id]) info = data.products[id];
    if (!info) return;
    var average = info.average;
    var count = info.count;
    var label = average + ' (' + count + (count === 1 ? ' review' : ' reviews') + ')';
    var inner = renderStars(average);
    if (showCount) inner += '<span class="review-stars-widget__count">(' + count + ')</span>';
    var link = linkToReviews ? (reviewsPageUrl + (reviewsPageUrl.indexOf('?') >= 0 ? '&' : '?') + 'product=' + encodeURIComponent(handle)) : '#';
    widget.innerHTML = linkToReviews
      ? '<a href="' + link + '" class="review-stars-widget__link">' + inner + '</a>'
      : '<span class="review-stars-widget__link">' + inner + '</span>';
    widget.classList.add('review-stars-widget--loaded');
  }

  function run(summary) {
    var data = summary && (summary.by_handle || summary.products) ? summary : null;
    if (!data) return;
    for (var i = 0; i < widgets.length; i++) fillWidget(widgets[i], data);
  }

  fetch(summaryUrl)
    .then(function(res) { return res.json(); })
    .then(run)
    .catch(function() {});
})();
